import classNames from "../../../utils/classNames"


export const TextInput = ({
  label,
  register,
  registerName,
  disabled = false,
  type = "text",
  richText = false,
  cols = "sm:col-span-1",
  customClasses = "",
  rows = 2,
  initialValue = "",
  placeholder = "",
  maxLength = 524288,
}) => {

  const classes = classNames(
    disabled ? "bg-gray-300" : "",
    `w-full py-1 px-1 mt-1 text-sm text-gray-900 border border-border ${customClasses}`
  )

  return (
    <div className={cols}>
      <label className="text-sm font-medium text-gray-500">
        {label}
      </label>
      {
        richText ?
          <textarea
            {...register(registerName)}
            disabled={disabled}
            className={classes}
            rows={rows}
            defaultValue={initialValue}
            placeholder={placeholder}
          />
          :
          <input
            {...register(registerName)}
            disabled={disabled}
            type={type}
            className={classes}
            defaultValue={initialValue}
            maxLength={maxLength}
            placeholder={placeholder}
          />
      }
    </div>
  )
}